import { Component, OnInit, ChangeDetectorRef, ApplicationRef, ViewChild} from '@angular/core';
import { BaseService } from '../../../services/base.services';
import {NgbDate, NgbCalendar, NgbDateParserFormatter, NgbTabsetConfig, NgbDateStruct, NgbTabset} from '@ng-bootstrap/ng-bootstrap';
import pageSettings from '../../../config/page-settings';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { formatDate} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material';
import { DaterangepickerComponent, DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { NgxChartsModule, id } from '@swimlane/ngx-charts';
import * as moment from 'moment';

import 'nvd3';
declare var Highcharts: any;
declare var nv: any;
declare var html2canvas:any;
declare var myExcelXML: any;

import * as swal from 'sweetalert2';
import * as global from '../../../config/globals';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';
@Component({
  selector: 'admin',
  templateUrl: './admin.html',
  styleUrls: ['admin.css']
})

export class AdminPage implements OnInit{
  private data:Array<any> = [];
  load = false;
  load2 = false;
  load_search = true;
  cargando = false;
  actualizando = false;
  verCorreo = 0;
  verFFin = 0;
  pageSettings = pageSettings;
  finish = false;
  todaySurvey = false;
  country = 'chile';
  final = false;
  listTodaySurvey = false;
  nombre;
  apellido;
  email: any = '';
  direccion;
  empresa;
  oficina;
  responseForm;
  warning;
  dataUser;
  currentOffice = 1;
  currentCompany = 1;
  otraEmpresa = false;
  otraOficina = false;
  otraEnfermedad = false;
  edad;
  show = true;
  show2 = true;
  paso1= false;
  paso2= false;
  paso3= false;
  loading = false;
  loadingExcel = false;
  loading_search = true;
  encuesta: any;
  solicitud:any = {};
  idAreaSeleccionada = 0;
  mostrarDeclaracion = false;
  mostrarEstado = false;
  areaSeleccionadaVisitantes;
  nombres;
  apellidos;
  telefono;
  hash;
  datosEncuestadosLocal;
  declaracion = false;
  sinRiesgo = false;
  storage;
  solicitudSeleccionada:any = {};
  emailIncorrecto = false;
  inhabilitarCampo = false;
  esAdministrador = false;
  empresaSeleccionada = 1;
  areaSeleccionada;
  finalEstado = false;
  ocultarChart = false;
  listEmpresas: any = [];
  listArea: any = [];
  listEstadosSolicitudPersonal:any = [];
  fechaInicio: NgbDateStruct;
  horaInicio: any;
  fechaFin:NgbDateStruct;
  horaFin:any;
  motivo: any;
  rut: any;
  total = 0;
  aprobadas = 0;
  rechazadas = 0;
  listSolicitudes:any = [];
  listSolicitudesFilter:any = [];
  listSolicitudesFilterAprobadas: any = [];
  listSolicitudesFilterPendientes: any = [];
  listEmpresasEnArea: any = [];
  listTareasAreas: any = [];
  totalPersonasEnAreas = 0;
  totalEmpresasEnAreas = 0;
  AreaSeleccionada = '';
  listVisitas:any = [];
  listNuevasPersonas = [];
  disableRut= false;
  listPersonasVisitantes = []
  urlAdministrador = false;
  rangoFechaInicio: any;
  rangoFechaFin:any;
  buscar;
  buscarSolicitud;
  buscarSolicitudAprobada;
  buscarSolicitudPendiente;
  esGrupal = false;
  showQR= false;
  caja1 = 0;
  caja2 = 0;
  caja3 = 0;
  caja4 = 0;
  downloadCSV;
  numPersonas:any = 1;
    /* Daterangepicker */
    rangoFecha: {startDate: moment.Moment, endDate: moment.Moment};
    @ViewChild(DaterangepickerDirective, {static: true}) pickerDirective: DaterangepickerDirective;
    inlineDate: any;
    inlineDateTime: any;
    picker: DaterangepickerComponent;
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    prevDate: any = moment().subtract('days', 15).format('D MMMM') + ' - ' + moment().subtract('days', 8).format('D MMMM YYYY');
    ranges: any = {
      'Hoy': [moment(), moment()],
      //'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      '7 días': [moment().subtract(6, 'days'), moment()],
      '30 días': [moment().subtract(29, 'days'), moment()],
      //'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Mes pasado': [
        moment()
          .subtract(1, 'month')
          .startOf('month'),
        moment()
          .subtract(1, 'month')
          .endOf('month')
      ]
    };
    locale: any = {
      format: 'D MMMM YYYY',
      displayFormat: 'D MMMM YYYY',
      separator: ' - ',
      cancelLabel: 'Cancelar',
      applyLabel: 'Aceptar',
      clearLabel: 'Limpiar'
    }
  

    multi: any[];
    view: any[] = [700, 400];
  
    // options
    showXAxis: boolean = true;
    showYAxis: boolean = true;
    gradient: boolean = true;
    showLegend: boolean = true;
    showXAxisLabel: boolean = true;
    xAxisLabel: string = 'Country';
    showYAxisLabel: boolean = true;
    yAxisLabel: string = 'Population';
    legendTitle: string = 'Years';
    colorScheme = {
      domain: ['#5AA454', '#C7B42C', '#AAAAAA']
    };

    listVisitantesActuales:any = [];
    listVisitantesActualesFilter: any = [];
    listVisitantesActualesFilter2: any = [];
    administrador: any;
    listEncontrados: any = [];
    rutaQRCompartir = 'rutaQR';
    rutaQRPase = 'rutaQR';
    imgQRCompartir;
    fechaIBox;
    fechaFBox;
    areaVisitantesSeleccionada: any = {
      idArea: 'todas',
      nombre: 'Todas',
      gerencia: null,
      telefono: ''
    };
    areaVisitantesSeleccionada2: any = {
      idArea: 'todas',
      nombre: 'Todas',
      gerencia: null,
      telefono: ''
    };
    areaPendientesSeleccionada: any = {
      idArea: 'todas',
      nombre: 'Todas',
      gerencia: null,
      telefono: ''
    };
    areaAprobadasSeleccionada: any = {
      idArea: 'todas',
      nombre: 'Todas',
      gerencia: null,
      telefono: ''
    };
    selectedTab:string; 

    dataSolicitudes:any;

    btnResumen:boolean = false;
    pageNumber1:number = 0;
    pageNumber2:number = 0;
    pageNumber3:number = 0;
    pageNumber4:number = 0;
    pageNumber5:number = 0;

    @ViewChild('tabs', {static: true})
    private tabs:NgbTabset; 
  public constructor(
    private baseService: BaseService,
    private calendar: NgbCalendar, 
    public formatter: NgbDateParserFormatter,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private cd : ChangeDetectorRef,
    private route: ActivatedRoute,
    private appRef: ApplicationRef,
    private config: NgbTabsetConfig
    ) {

      this.pageSettings.pageEmpty = false;
      this.pageSettings.pageWithoutSidebar = true;
      this.pageSettings.appSelected = null;
      config.justify = 'center';
      //config.type = 'pills';
      var fechaInicio = moment();
      var fechaFin = moment().add(12, 'hours');


      this.horaInicio =  {hour: parseInt(fechaInicio.format("HH")), minute: parseInt(fechaInicio.format("mm"))};
      this.horaFin =  {hour: parseInt(fechaFin.format("HH")), minute: 0};

      this.fechaInicio = {year: parseInt(fechaInicio.format("YYYY")), month: parseInt(fechaInicio.format("MM")), day: parseInt(fechaInicio.format("DD"))};
      this.fechaFin = {year: parseInt(fechaFin.format("YYYY")), month: parseInt(fechaFin.format("MM")), day: parseInt(fechaFin.format("DD"))};

      this.country = this.route.snapshot.paramMap.get('pais') == null ? 'chile' : this.route.snapshot.paramMap.get('pais');
      
      this.alwaysShowCalendars = true;
      this.keepCalendarOpeningWithRange = true;
      this.showRangeLabelOnInput = true;
      this.rangoFecha = {
        startDate: moment().subtract('days', 1),
        endDate: moment()
      };
  }

  async ngOnInit()  {

    this.mostrarDeclaracion = false; 
    this.paso1 = false;
    this.esAdministrador = true;

    this.getAreas();
    this.get_EstadoSolicitud();
    this.get_Solicitudes();

    let data_all = {
      idArea: 'todas'
    }

    this.changeAreaFilterVisitantes(data_all);

    //establecer fechas por defecto
    this.rangoFechaInicio = this.rangoFecha.startDate.format("YYYY-MM-DD HH:mm:ss");
    this.rangoFechaFin = this.rangoFecha.endDate.format("YYYY-MM-DD HH:mm:ss");
    //***/

    setInterval(()=>{    
      this.rangoFechaInicio = this.rangoFecha.startDate.format("YYYY-MM-DD HH:mm:ss");
      this.rangoFechaFin = this.rangoFecha.endDate.format("YYYY-MM-DD HH:mm:ss");
      this.fechaIBox = this.rangoFecha.startDate.format("DD-MM-YYYY");
      this.fechaFBox = this.rangoFecha.endDate.format("DD-MM-YYYY");
      if(!this.actualizando){
        this.get_Solicitudes();
      }
      
    }, 30000);

    // setInterval(()=>{    
    //   this.rangoFechaInicio = this.rangoFecha.startDate.format("YYYY-MM-DD HH:mm:ss");
    //   this.rangoFechaFin = this.rangoFecha.endDate.format("YYYY-MM-DD HH:mm:ss");
    //   this.fechaIBox = this.rangoFecha.startDate.format("DD-MM-YYYY");
    //   this.fechaFBox = this.rangoFecha.endDate.format("DD-MM-YYYY");
    //   this.get_Solicitudes(); //actualizar data sin refrescar pagina cada 10min
    //   //this.get_empresas_en_area();
    // }, 600000);

  }

  nextPage(max,filt){
    let max_pag;
    if(max>0){
      max_pag = Math.round(max/10);
    }

    if(filt==1){
      if((Math.round(this.pageNumber1/10))<max_pag){
        this.pageNumber1 += 10;
      }
    }else if(filt==2){
      if((Math.round(this.pageNumber2/10))<max_pag){
        this.pageNumber2 += 10;
      }
    }else if(filt==3){
      if((Math.round(this.pageNumber3/10))<max_pag){
        this.pageNumber3 += 10;
      }
    }else if(filt==4){
      if((Math.round(this.pageNumber4/10))<max_pag){
        this.pageNumber4 += 10;
      }
    }else if(filt==5){
      if((Math.round(this.pageNumber5/10))<max_pag){
        this.pageNumber5 += 10;
      }
    }

  }

  prevPage(filt){

    if(filt==1){
      if(this.pageNumber1>0){
        this.pageNumber1 -= 10;
      }
    }else if(filt==2){
      if(this.pageNumber2>0){
        this.pageNumber2 -= 10;
      }
    }else if(filt==3){
      if(this.pageNumber3>0){
        this.pageNumber3 -= 10;
      }
    }else if(filt==4){
      if(this.pageNumber4>0){
        this.pageNumber4 -= 10;
      }
    }else if(filt==5){
      if(this.pageNumber5>0){
        this.pageNumber5 -= 10;
      }
    }


    
  }

  getDashboard(){
    var aprobadas = this.listSolicitudes.filter(x=> x.idEstado == 2);
    this.aprobadas = aprobadas ? aprobadas.length : 0;
    var rechazadas = this.listSolicitudes.filter(x=> x.idEstado == 3);
    this.rechazadas = rechazadas ? rechazadas.length : 0;
    this.total = this.listSolicitudes.length;        

    var dates = this.getDates();
    var dataChart = [];
    this.listArea.forEach(x=>{
      dataChart.push({name: x.nombre, color: global.COLOR_BLUE, series: this.getDataChart(x.nombre)});
    });

    this.multi = dataChart;
    
  }

  aprobarMarcados(){
    this.listSolicitudesFilter.forEach(x=>{
      if(x.idEstado == 1){
        x.idEstado = 2;
      }
    });
    this.toastr.success('todas las solicitudes ha sido aprobada');
  }
  
  
  async get_empresas_en_area(idarea){

      try{
        //tareas
        var response: any = await this.baseService.get_Tareas({}).toPromise();
        //this.listTareasAreas = response;
        this.listTareasAreas = [
          {Tarea: 'Bloqueo'},
          {Tarea: 'Espacios confinados'},
          {Tarea: 'Izaje de Carga'},
          {Tarea: 'Trabajos en Caliente'},
          {Tarea: 'No realizaré actividades críticas'}
        ];

        //empresa en area
        var response2: any = await this.baseService.get_empresas_en_area({idArea:idarea}).toPromise();
        let totalPersonal = 0;
        //obtener total personal de todas las empresas
        if(response2 && response2.length){

          response2.forEach(async item =>  {
            totalPersonal = totalPersonal + item.total_personal;
            if(idarea==0){
              this.AreaSeleccionada = 'Todas las áreas';
            }else{
              this.AreaSeleccionada = item.area;
            }
          })
  
          this.totalPersonasEnAreas = totalPersonal;
          this.listEmpresasEnArea = response2;

        }else{
          this.totalPersonasEnAreas = 0;
          this.listEmpresasEnArea = [];
        }

  
      }catch(error){
        console.log(error);
      }    

  }

  async get_DetalleXEstado(){

    try {
      var _storage = JSON.parse(localStorage.getItem('admin'));
      var response: any = await this.baseService.get_DetalleXEstado({idUsuario: _storage.usuario.IDUSUARIO}).toPromise();
      this.listVisitantesActuales = response;
      this.load2 = true;

      this.listVisitantesActualesFilter =  JSON.parse(JSON.stringify(response));

      this.listVisitantesActualesFilter = this.listVisitantesActuales;

      this.cajas();

      if(this.areaVisitantesSeleccionada && this.areaVisitantesSeleccionada.idArea !== 'todas'){
        this.listVisitantesActualesFilter = this.listVisitantesActuales.filter(x=> x.area.toUpperCase() == this.areaVisitantesSeleccionada.nombre.toUpperCase());
      }else{
        this.listVisitantesActualesFilter = this.listVisitantesActuales;
      }

    }catch(error){
      console.log(error);
      this.load2 = true;
    }

  }

  selectTabs(tab){

    if(this.tabs) {
      this.tabs.select(tab);
    }

  }

  async marcarSolicitud(item, idEstado, comentario){
    try {

      var response = await this.baseService.aprobar_Solicitud({idSolicitud: item.idSolicitud, idEstado: idEstado, Comentario: comentario}).toPromise();
      item.idEstado = idEstado;
      var data = {idSolicitud: item.idSolicitud};
      var personal: any = await this.baseService.get_SolicitudesPersonal(data).toPromise();

      let id_personal = [], estados_personal = [], emails_personal = [];

      var data2 = {
        email: '',
        idSolicitud:0,
        idPersonal: 0,
        tipo: idEstado == 2 ? 'Aprobada' : 'Rechazada',
        empresa: item.empresa,
        area:  item.area,
        fecha: 'Desde el '+ this.formatedDateUser(item.fechaInicio) + ' hasta el ' + this.formatedDateUser(item.fechaFin),
        nombre: ''
      }

      if(personal.length > 0){
        personal.forEach(async x =>  {
          if(x.idEstado == 1){
            if(typeof x.aprobado !== "undefined"){
              var estado = x.aprobado ? 2 : 3;
            }
            data2.idSolicitud = item.idSolicitud,
            data2.idPersonal = x.idPersonal,
            data2.email = x.email;
            data2.nombre = x.nombres + ' ' + x.apellidos;

            //personal
            id_personal.push(x.idPersonal);
            estados_personal.push(idEstado);

            try {
              await this.baseService.enviar_email(data2).toPromise();
            } catch (error) {
              console.error(`Error: ${error}`);
            }
            
            //await this.setEstadoPersonal(data2.idSolicitud, x.idPersonal, idEstado);
          }    
        });

        //update todos los estados del personal
        this.setEstadosPersonal(item.idSolicitud,id_personal,estados_personal);

      }

      this.toastr.success('La solicitud ha sido modificada');
  
    } catch(error) {
      this.toastr.error('Ha ocurrido un problema');
    }
  }

  async marcarSolicitudIndividual(item, idEstado){

    var response:any = await this.setEstadoPersonal(item.idSolicitud, item.idPersonal, idEstado);

    if(idEstado== 2 || idEstado == 3){
      var data2 = {
        email: item.email,
        idSolicitud:item.idSolicitud,
        idPersonal: item.idPersonal,
        tipo: idEstado == 2 ? 'Aprobada' : 'Rechazada',
        empresa: item.empresa,
        area:  item.area,
        fecha: 'Desde el '+ this.formatedDateUser(item.fechaInicio) + ' hasta el ' + this.formatedDateUser(item.fechaFin),
        nombre: item.Persona
      }
      await this.baseService.enviar_email(data2).toPromise();
    }
    this.buscarPersonal(item.idSolicitud);
  }

  async marcarSolicitudModal(content, comentario){

    try {
      var _storage = JSON.parse(localStorage.getItem('admin'));
      var response = await this.baseService.aprobar_Solicitud(
        { idSolicitud: this.solicitudSeleccionada.idSolicitud, 
          idEstado: 2, 
          Comentario: comentario, 
          idUsuario: _storage.usuario.IDUSUARIO
        }
      ).toPromise();

      if(this.listPersonasVisitantes.length > 0){

        let aprobados = [];
        let id_personal = [], estados_personal = [], emails_personal = [];

        this.listPersonasVisitantes.forEach(async (x, index) => {
          try {

            if(x.idEstado == 1){
              aprobados[index] = x.idEstado;
              var estado = x.aprobado ? 2 : 3;
              //this.setEstadoPersonal(this.solicitudSeleccionada.idSolicitud, x.idPersonal, estado);
              id_personal.push(x.idPersonal);
              estados_personal.push(estado);
            }else{
              aprobados[index] = null;
            }

          } catch (error) {
            console.error(`Error en el índice ${index}: ${error}`);
          }
        });

        //update todos los estados del personal
        this.setEstadosPersonal(this.solicitudSeleccionada.idSolicitud,id_personal,estados_personal);

        this.listPersonasVisitantes.forEach(async (x, index) => {
          try {
            if(aprobados[index] && aprobados[index] == 1){
              var data2 = {
                email : x.email,
                tipo:  x.aprobado ? 'Aprobada' : 'Rechazada',
                empresa: this.solicitudSeleccionada.empresa,
                fecha: 'Desde el '+ this.formatedDateUser(this.solicitudSeleccionada.fechaInicio) + ' hasta el ' + this.formatedDateUser(this.solicitudSeleccionada.fechaFin),   
                area:  this.solicitudSeleccionada.area,
                nombre: x.nombres +' '+ x.apellidos,
                idSolicitud: this.solicitudSeleccionada.idSolicitud,
                idPersonal: x.idPersonal,
              }
              await this.baseService.enviar_email(data2).toPromise();
            }
          } catch (error) {
            console.error(`Error en el índice ${index}: ${error}`);
          }

        });
      }

      this.get_Solicitudes();
      this.modalService.dismissAll(content);
      this.toastr.success('La solicitud ha sido modificada');
      this.refreshPage();
    } catch(error) {
      this.toastr.error('Ha ocurrido un problema');
    }
  }

  doTextareaValueChange(ev) {
    try {
      this.motivo = ev.target.value;
    } catch(e) {
      console.info('could not set textarea-value');
    }
  }

  async getUser(rut){
    var usuario = this.listNuevasPersonas.filter(x=> x.rut == rut);
    if(usuario.length > 0){
      this.rut = usuario[0].rut;
      this.nombres = usuario[0].nombres;
      this.apellidos = usuario[0].apellidos;
      this.email = usuario[0].email;
      this.telefono = usuario[0].telefono;
    }else {
      var body = {
        Division: 'DCH',
        Validador: rut,
        Captcha: 0
      }
      var response : any = await this.baseService.sp_Login(body).toPromise();
      if(response.length > 0){
        this.rut = response[0].rut;
        this.nombres = response[0].nombres;
        this.apellidos = response[0].apellidos;
        this.email = response[0].email;
        this.telefono = response[0].telefono;
      }else{
        this.rut = rut;
        this.nombres = '';
        this.apellidos = '';
        this.email = '';
        this.telefono = '';
      }
    }
  }


  resetExclusivo(item, preguntas){
    if(item.pregunta.Exclusivo){
      preguntas.forEach(x=>{
        if(x.pregunta.idPregunta !== item.pregunta.idPregunta){
          x.respuestaUsuario = null;
        }
      });
    }
  }

  validar1(){
    if(!this.motivo){
      this.toastr.error('Llene todos los campos', '');
      return;
    }

    let fechaHoy =  moment(); 
    let fechaInicio =  moment(`${this.fechaInicio.year}-${this.fechaInicio.month}-${this.fechaInicio.day} ${this.horaInicio.hour}:${this.horaInicio.minute}`); 
    let fechaFin =  moment(`${this.fechaFin.year}-${this.fechaFin.month}-${this.fechaFin.day} ${this.horaFin.hour}:${this.horaFin.minute}`); 
    

    if(fechaInicio.diff(fechaHoy, 'hours') < 0){
      this.toastr.error('La fecha y hora de inicio no debe ser menor a la fecha y hora actual', '');
      return;
    }

    if(this.verFFin && fechaFin.diff(fechaInicio, 'hours') < 0){
      this.toastr.error('La fecha inicio no debe ser mayor a la fecha fin', '');
      return;
    }

    if(this.verFFin && fechaFin.diff(fechaInicio, 'hours') > 12){
      this.toastr.error('La diferencia entre las fechas no puede superar las 12 horas', '');
      return;
    };

    this.paso1 = false;
    this.paso2 = true;
  }

  async openmodal(content, solicitud, opc = null) {

    this.idAreaSeleccionada = solicitud;

    if(opc==1){

      await  this.get_empresas_en_area(solicitud);
   
      this.modalService.open(content, { size: 'lg' });

    }else{

      if(solicitud !== 0){
        this.solicitudSeleccionada = solicitud;
        await  this.get_SolicitudesPersonal(solicitud.idSolicitud);
        this.modalService.open(content, { size: 'lg' });

      }else{
        this.solicitudSeleccionada = solicitud;
        this.modalService.open(content, { size: 'lg' });
      }

      console.log(this.solicitudSeleccionada, "Solicitud seleccionada");


    }
    
  }

  async validar2(){
    if(this.esGrupal){
      if(!this.numPersonas || this.numPersonas < 2){
        this.toastr.error('Si selecciona solicitud grupal debe de incluir a más de una persona', '');
        return;
      }
    }else{
      this.numPersonas = 1
    }

    if(this.listNuevasPersonas.length == 0){
      this.toastr.error('Ingrese al menos sus datos de usuario', '');
      return;
    }

    await this.guardarSolicitud();

  }

  changeAprobar(data){
    console.log(data);
  }

  atrasUsuario(){
    this.rut = this.listNuevasPersonas[0].rut;
    this.nombres = this.listNuevasPersonas[0].nombres;
    this.apellidos = this.listNuevasPersonas[0].apellidos;
    this.email = this.listNuevasPersonas[0].email;
    this.telefono = this.listNuevasPersonas[0].telefono;
    this.paso3 = false;    
    this.paso2 = true;    
  }

  setDatosUsuarios(data){
    this.rut = data.rut;
    this.nombres = data.nombres;
    this.apellidos = data.apellidos;
    this.email = data.email;
    this.telefono = data.telefono;
  }

  savemodal(content) {
    if(!this.rut || !this.nombres || !this.apellidos || !this.telefono){
      this.toastr.error('Por favor llenar todos los campos', '');
      
      return;
    }
    
    if(this.verCorreo && !this.verCorreo){
      this.toastr.error('Por favor llenar todos los campos', '');  
      return;
    }

    if(this.verCorreo && !this.validateEmail()) {
      this.toastr.error('Ingrese correctamente el email', '');
      return;
    }

    if(this.paso2){
      this.paso2 = false; 
      this.paso3 = true;
    }
    
    var user = {
      rut: this.rut,
      nombres: this.nombres,
      apellidos: this.apellidos,
      email: this.email,
      telefono: this.telefono,
      esPrincipal: this.storage.Validador == this.rut ? 1 : 0,
    }
    this.listNuevasPersonas = this.listNuevasPersonas.filter(x=> x.rut !== this.rut);
    this.listNuevasPersonas.push(user);
    this.modalService.dismissAll(content);
    this.rut = '';
    this.nombres = '';
    this.apellidos = '';
    this.email = '';
    this.telefono = '';
    this.disableRut = false;
  }

  formatedDate(fecha, hora){
    return moment(`${fecha.year}-${fecha.month}-${fecha.day} ${hora.hour}:${hora.minute}`, "YYYY-MM-DD H:m").format("YYYY-MM-DD HH:mm:ss");
  }
  
  
  formatedDateUser(fecha){
    return moment(fecha, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm");
  }
  

  async guardarSolicitud(){
    var body= {
      idArea: this.areaSeleccionada, 
      fechaInicio: this.formatedDate(this.fechaInicio, this.horaInicio), 
      fechaFin: this.formatedDate(this.fechaFin, this.horaFin),
      motivo: this.motivo,
      empresa: this.empresa,
      numPersonas: this.numPersonas
    }
    var solicitud : any = await this.baseService.add_Solicitud(body).toPromise();
    var _empresa = this.listEmpresas.filter(y=> y.idEmpresa == this.empresaSeleccionada);
    var _area = this.listArea.filter(y=> y.idArea == this.areaSeleccionada);
    _empresa = _empresa.nombre;
    _area = _area.nombre;
    
    this.rutaQRCompartir = await window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/qr/'+ solicitud[0].idSolicitud;

    await this.listNuevasPersonas.forEach( async x =>  {
      var body1 ={
        nombres: x.nombres, 
        apellidos: x.apellidos,
        email	: x.email,
        telefono: x.telefono,
        idEmpresa: this.empresaSeleccionada,
        empresa: '',
        rut: x.rut
      }
      this.rutaQRPase = this.rutaQRPase =  window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/check/'+ x.rut;

      var personal : any = await this.baseService.add_Personal(body1).toPromise();
      var solicitudPersonal : any = await this.baseService.add_SolicitudPersonal({
        idSolicitud: solicitud[0].idSolicitud, 
        idPersonal	: personal[0].idPersonal, 
        esPrincipal: x.esPrincipal ? 1 : 0
      }).toPromise();

      var data2 = {
        email: '', 
        tipo: 'Enviada',
        empresa: _empresa,
        area:  _area,
        fecha: 'Desde el '+ body.fechaInicio + ' hasta el ' + body.fechaFin,
        nombre: '',
        idSolicitud: '',
        idPersonal: '',
      }
      data2.idSolicitud = solicitud[0].idSolicitud,
      data2.idPersonal = personal[0].idPersonal,
      data2.email = x.email;
      data2.nombre = x.nombres + ' ' + x.apellidos;
      if(this.esGrupal){
        var elemC = document.getElementById('QRcompartir').querySelectorAll('div, img');
        var qrC = elemC[0].innerHTML.replace('">', '').replace('<img src="', '');  
        await this.baseService.add_QRSolicitud({idSolicitud: solicitud[0].idSolicitud, QRCode: qrC}).toPromise();
      }

      var elemP = document.getElementById('QRPase').querySelectorAll('div, img');
      var qrP = elemP[0].innerHTML.replace('">', '').replace('<img src="', '');
      
      await this.baseService.add_QRSolicitudPersona({idSolicitud: solicitud[0].idSolicitud, idPersonal: data2.idPersonal, QRCode: qrP}).toPromise();

      await this.baseService.enviar_email(data2).toPromise();
    });
    this.get_Solicitudes();
    this.mostrarDeclaracion = true; 
    this.paso3 = false; 
    this.esAdministrador=false;
    this.toastr.success('Su solicitud se ha enviado satisfactoriamente', '');
  }
  
  async getHash(){
    try{
      var _storage = JSON.parse(localStorage.getItem('admin'));
      if(_storage){
        var response: any = await this.baseService.get_GUID({}).toPromise();
        this.hash = response[0].HashCode;
      }
      
    }catch(error){
      console.log(error);
    }    
  }


  quitarPersonal(item: any){
    this.listNuevasPersonas = this.listNuevasPersonas.filter(x=> x.rut !== item.rut);
  }

  async getSolicitudesPersona(data){
    try {
      var response:any = await this.baseService.get_SolicitudesPersona(data).toPromise();
      this.cargando = false;
      if(response.length > 0){ 
        this.mostrarEstado = true;
        this.paso1 = false;
        this.solicitud = response[0];
        this.rutaQRCompartir =  window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/qr/'+ response[0].idSolicitud;
        this.rutaQRPase =  window.location.protocol+'//'+ window.location.hostname+( window.location.port ? ':'+ window.location.port: '')  +'/#/check/'+ response[0].rut;
      }

    }catch(error) {
      console.log(error);
    }
  }

  async set_estado_solicitud_personal(data){
    try {
      var response:any = await this.baseService.set_estado_solicitud_personal(data).toPromise();
      this.toastr.success('El estado de la solicitud ha sido modificado','');
      var response:any = await  this.get_SolicitudesPersonal(data.idSolicitud);

    }catch(error) {
      console.log(error);
    }
  }

  async get_EstadoSolicitud(){
    try {
      var response:any = await this.baseService.get_EstadoSolicitud().toPromise();
      this.listEstadosSolicitudPersonal = response;

    }catch(error) {
      console.log(error);
    }
  }

  async setEstadoPersonal(idSolicitud, idPersonal, estado){
    var _storage = JSON.parse(localStorage.getItem('admin'));

    var data = {idSolicitud: idSolicitud, idPersonal: idPersonal, idEstado: estado, idUsuario: _storage.usuario.IDUSUARIO};
    var response = await this.set_estado_solicitud_personal(data);
    if(!this.esAdministrador){      
      this.reset();
      if(estado == 5){
        this.mostrarEstado = false;
      }
    }
    return response;
  }

  reset(){
    var body = {
      Division: 'DCH',
      Validador: this.storage.Validador,
      Captcha: 0
    }
    this.mostrarDeclaracion = false;
    this.getLogin(body);
  }
  
  async getLogin(body){
    try{
      var response : any = await this.baseService.sp_Login(body).toPromise();
      if(response.length > 0){
        if(response[0].esAdministrador) {
          this.mostrarDeclaracion = false; 
          this.paso1 = false;
          this.esAdministrador = true;
          this.administrador = response[0];
         
          await this.get_Solicitudes();
          await this.get_EstadoSolicitud();
          //this.getDashboard();
          return;
        }
        this.cargando = true;
        this.getSolicitudesPersona({idPersonal: response[0].idPersonal});
        this.setDatosUsuarios(response[0]);
        this.listNuevasPersonas.push(response[0]); 
      }else{
        this.disableRut = true; 
        this.rut = this.storage.Validador
      }

      this.paso1 = true;
    }catch(error){
      console.log(error);
      //this.router.navigate(['/'], { replaceUrl: true });
    }    
  }

  async add_Resultado(data){
    try{
      var response: any = await this.baseService.add_Resultado(data).toPromise();
  
      return response;
    }catch(error){
      console.log(error);
    }    
  }



  async get_Solicitudes(){
  
    try{
      
      var _storage = JSON.parse(localStorage.getItem('admin'));
      var data = {idEmpresa: 'DCH', fechaInicio: this.rangoFechaInicio, fechaFin: this.rangoFechaFin, idPersonal: 1, idUsuario: _storage.usuario.IDUSUARIO};
      var response: any = await this.baseService.get_Solicitudes(data).toPromise();

      //data cargada solicitudes filter pendientes y aprobadas
      this.load = true;

      response.map(x=>{
        x.fechaI = this.formatedDateUser(x.fechaInicio);
        x.fechaF = this.formatedDateUser(x.fechaFin);
      });

      this.listSolicitudes = response;
      this.listSolicitudesFilter = JSON.parse(JSON.stringify(response));

      this.get_DetalleXEstado();

      //filtros de solicitudes pendientes
      if(this.areaPendientesSeleccionada.idArea!=='todas'){
        this.listSolicitudesFilterPendientes = JSON.parse(JSON.stringify(response.filter(x=>x.idArea == this.areaPendientesSeleccionada.idArea)));
      }else{
        this.listSolicitudesFilterPendientes = JSON.parse(JSON.stringify(response.filter(x=>x.idEstado == 1)));
      }

      //filtros de solicitudes aprobadas
      if(this.areaAprobadasSeleccionada.idArea!=='todas'){
        this.listSolicitudesFilterAprobadas = JSON.parse(JSON.stringify(response.filter(x=>x.idArea == this.areaAprobadasSeleccionada.idArea)));
      }else{
        this.listSolicitudesFilterAprobadas = JSON.parse(JSON.stringify(response.filter(x=>x.idEstado == 2)));
      }

      //filtros de solicitudes en area
      if(this.areaVisitantesSeleccionada.idArea!=='todas'){
        this.listVisitantesActualesFilter = this.listVisitantesActuales.filter(x=> x.area.toUpperCase()  == this.areaVisitantesSeleccionada.nombre.toUpperCase());
      }else{
        this.listVisitantesActualesFilter = this.listVisitantesActuales;
      }

      //filtro de solicitudes en area critica
      if(this.areaVisitantesSeleccionada2.idArea !== 'todas'){
        this.listVisitantesActualesFilter2 = this.listVisitantesActuales.filter(x=> x.area.toUpperCase()  == this.areaVisitantesSeleccionada2.nombre.toUpperCase());
      }else {
        this.listVisitantesActualesFilter2 = this.listVisitantesActuales;
      }

      return response;

    }catch(error){
      console.log(error);
      this.load = true;
    }    


    
  }

  async get_SolicitudesExcel(){
    try{
      var _storage = JSON.parse(localStorage.getItem('admin'));
      this.loading = true;
      var data = {idEmpresa: 'DCH', fechaInicio: this.rangoFechaInicio, fechaFin: this.rangoFechaFin, idPersonal: 1, idUsuario: _storage.usuario.IDUSUARIO};
      var response: any = await this.baseService.get_SolicitudesExcel(data).toPromise();
      this.loading = false;
      response.map(x=>{
        x.fechaI = this.formatedDateUser(x.fechaInicio);
        x.fechaF = this.formatedDateUser(x.fechaFin);
      });

      this.download(response);


    
      return response;
    }catch(error){
      console.error(error);
    }    
  }

  async refreshPage() {

    this.actualizando = true;

    //actualizar variables con data
    await this.getAreas();
    await this.get_Solicitudes();
    await this.get_EstadoSolicitud();
    await this.get_DetalleXEstado();
    //this.get_empresas_en_area();
    this.toastr.success('Información actualizada');
    this.get_empresas_en_area(this.areaVisitantesSeleccionada.idArea);
    
    this.actualizando = false;
    //window.location.reload();
   }

  changeAreaFilter($event){

    this.listSolicitudesFilter = this.listSolicitudes.filter(x=> x.idArea == $event.target.value);
  }

  async changeAreaFilterVisitantes($event) {

    if($event){
      //this.areaVisitantesSeleccionada = $event.target.value;
      this.areaVisitantesSeleccionada = $event;
      this.idAreaSeleccionada = $event;
      //if($event.target.value == 'todos'){
      if($event.idArea == 'todas'){
        this.idAreaSeleccionada = 0;
        this.listVisitantesActualesFilter = this.listVisitantesActuales;
      }else {
        this.idAreaSeleccionada = $event;
        this.areaSeleccionada = $event.nombre;
        //this.listVisitantesActualesFilter = this.listVisitantesActuales.filter(x=> x.area.toUpperCase()  == $event.target.value.toUpperCase());
        this.listVisitantesActualesFilter = this.listVisitantesActuales.filter(x=> x.area.toUpperCase()  == $event.nombre.toUpperCase());
      }

      //imprimir tabla resumen en: Personas dentro del area
      if($event.idArea=='todas'){
        //this.get_empresas_en_area(0);
        this.btnResumen = false;
      }else{
        await this.get_empresas_en_area($event.idArea);
        this.btnResumen = true; //habilitar btn resumen en tab areas
      }

      this.pageNumber3 = 0;

    }

  }

  changeAreaFilterVisitantes2($event) {

    if($event){
      //this.areaVisitantesSeleccionada = $event.target.value;
      this.areaVisitantesSeleccionada2 = $event;
      //if($event.target.value == 'todos'){
      if($event.idArea == 'todas'){
        this.listVisitantesActualesFilter2 = this.listVisitantesActuales;
      }else {
        //this.listVisitantesActualesFilter = this.listVisitantesActuales.filter(x=> x.area.toUpperCase()  == $event.target.value.toUpperCase());
        this.listVisitantesActualesFilter2 = this.listVisitantesActuales.filter(x=> x.area.toUpperCase()  == $event.nombre.toUpperCase());
      }

      //imprimir tabla resumen en: Personas dentro del area
      if($event.idArea=='todas'){
        //this.get_empresas_en_area(0);
      }else{
        this.get_empresas_en_area($event.idArea);
      }

      this.pageNumber4 = 0;

    }

  }

  changeAreaFilterPendientes($event) {

    if($event){

      this.areaPendientesSeleccionada = $event;

      if($event.idArea == 'todas'){

        this.listSolicitudesFilterPendientes = this.listSolicitudes;

      }else {
        this.listSolicitudesFilterPendientes = this.listSolicitudes.filter(x=> x.idArea  == $event.idArea);
      }

      this.pageNumber1 = 0;
    }
  }

  changeAreaFilterAprobadas($event) {

    if($event){

      //this.areaPendientesSeleccionada = $event.target.value;
      this.areaPendientesSeleccionada = $event;


      //if($event.target.value == 'todas'){
      if($event.idArea == 'todas'){
        this.listSolicitudesFilterAprobadas = this.listSolicitudes;
      }else {
        //this.listSolicitudesFilterAprobadas = this.listSolicitudes.filter(x=> x.idArea  == $event.target.value);
        this.listSolicitudesFilterAprobadas = this.listSolicitudes.filter(x=> x.idArea  == $event.idArea);
      }

      this.pageNumber2 = 0;

    }
    
  }


  changeCompanyFilter($event){
    this.listSolicitudesFilter = this.listSolicitudes.filter(x=> x.idEmpresa == $event.target.value);
  }

  changeSolicitudFilterPendientes(){

    if(this.buscarSolicitudPendiente == ''){

      this.listSolicitudesFilter = this.listSolicitudes;
      this.listSolicitudesFilterPendientes = this.listSolicitudesFilter;
    }else{

      let id_solicitud:[] = this.listSolicitudes.filter(
        x =>  x.idSolicitud.toString().indexOf(this.buscarSolicitudPendiente.toString()) !== -1
      );
      let area:[] = this.listSolicitudes.filter(
        x =>  x.area== this.buscarSolicitudPendiente.toString()
      );
      let empresa:[] = this.listSolicitudes.filter(
        x =>  x.empresa== this.buscarSolicitudPendiente.toString()
      );
      
      if(id_solicitud.length>0){
        this.listSolicitudesFilterPendientes = id_solicitud;
      }else if(area.length>0){
        this.listSolicitudesFilterPendientes = area;
      }else if(empresa.length>0){
        this.listSolicitudesFilterPendientes = empresa;
      }

    }

    this.pageNumber1 = 0;

  }

  changeSolicitudFilterAprobadas(){

    if(this.buscarSolicitudAprobada == ''){

      this.listSolicitudesFilter = this.listSolicitudes;
      this.listSolicitudesFilterAprobadas = this.listSolicitudesFilter;
    }else{

      // this.listSolicitudesFilter = this.listSolicitudes.filter(
      //   x =>  x.idSolicitud.toString().indexOf(this.buscarSolicitudAprobada.toString()) !== -1
      // );
      //   this.listSolicitudesFilterAprobadas = this.listSolicitudesFilter;

      

        let id_solicitud:[] = this.listSolicitudes.filter(
          x =>  x.idSolicitud.toString().indexOf(this.buscarSolicitudAprobada.toString()) !== -1
        );
        let area:[] = this.listSolicitudes.filter(
          x =>  x.area== this.buscarSolicitudAprobada.toString()
        );
        let empresa:[] = this.listSolicitudes.filter(
          x =>  x.empresa== this.buscarSolicitudAprobada.toString()
        );
        
        if(id_solicitud.length>0){
          this.listSolicitudesFilterAprobadas = id_solicitud;
        }else if(area.length>0){
          this.listSolicitudesFilterAprobadas = area;
        }else if(empresa.length>0){
          this.listSolicitudesFilterAprobadas = empresa;
        }


    }

    this.pageNumber2 = 0;

  }

  changeSolicitudFilter(){

    if(this.buscarSolicitud == ''){

      this.listSolicitudesFilter = this.listSolicitudes;
      this.listSolicitudesFilterPendientes = this.listSolicitudesFilter;
    }else{

      this.listSolicitudesFilter = this.listSolicitudes.filter(
        x =>  x.idSolicitud.toString().indexOf(this.buscarSolicitud.toString()) !== -1
      );
        this.listSolicitudesFilterPendientes = this.listSolicitudesFilter;
    }

  }

  async get_SolicitudesPersonal(idSolicitud:any){
    
    try{

      var data = {idSolicitud: idSolicitud};
      var response: any = await this.baseService.get_SolicitudesPersonal(data).toPromise();
      this.listPersonasVisitantes = response;
      this.listPersonasVisitantes.map(x=> x.aprobado = true);
      return response;

    }catch(error){
      console.log(error);
    }    

  }

  async buscarPersonal(idSolicitud:any){

    try{
      if(!this.buscar || this.buscar.trim() == ""){
        this.toastr.error('Por favor, ingresar nombre de persona, empresa o n° de solicitud para filtrar', '');
        return;
      }
      this.pageNumber5 = 0;
      this.load_search = false;
      this.loading_search = false;
      
      var _storage = JSON.parse(localStorage.getItem('admin'));
      var data = {texto: this.buscar, idEmpresa: 'DCH', fechaInicio: this.rangoFechaInicio, fechaFin: this.rangoFechaFin, idPersonal: 1, 
      idUsuario: _storage.usuario.IDUSUARIO};

      var response: any = await this.baseService.get_Solicitudes(data).toPromise();

      response.map(x=>{
        x.fechaI = this.formatedDateUser(x.fechaInicio);
        x.fechaF = this.formatedDateUser(x.fechaFin);
      });

      this.listEncontrados = [];
      this.listEncontrados = response;

      this.load_search = true;
      this.loading_search = true;



    }catch(error){
      console.log(error);
    }    
  }

  async enviar_email(data){
    try{
      var response: any = await this.baseService.enviar_email(data).toPromise();
    
      return response;
    }catch(error){
      console.log(error);
    }    
  }
  async add_Solicitud(data){
    try{
      var response: any = await this.baseService.add_Solicitud(data).toPromise();
   
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async add_SolicitudPersonal(data){
    try{
      var response: any = await this.baseService.add_SolicitudPersonal(data).toPromise();
   
      return response;
    }catch(error){
      console.log(error);
    }    
  }

  async add_Personal(data){
    try{
      var response: any = await this.baseService.add_Personal(data).toPromise();

      return response;
    }catch(error){
      console.log(error);
    }    
  }
  
  async getAreas(){
    try{

      this.loading = false;
      var _storage = JSON.parse(localStorage.getItem('admin'));
      var _areas: any = await this.baseService.get_AreasUsuario({idUsuario: _storage.usuario.IDUSUARIO}).toPromise();
     
      this.listArea = _areas;

      this.listArea.push({
        idArea: 'todas',
        nombre: 'Todas',
        gerencia: null,
        telefono: ''
      });

      if(_areas.length == 0){
        this.router.navigate(['/login'], { replaceUrl: true });
        return;
      }
      
      this.loading = false;


    }catch(error){
      this.router.navigate(['/login'], { replaceUrl: true });
      console.log(error);
    }    
  }

  volverLogin(){
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  async getEmpresas(){
    try{
      this.loading = false;
      var _storage = JSON.parse(localStorage.getItem('admin'));  
      var data: any = await this.baseService.get_empresas().toPromise();
      this.listEmpresas = data;
      this.empresaSeleccionada = data[0].idEmpresa;
      this.loading = false;
    }catch(error){
      console.log(error);
    }    
  }

  changeCompany(event){
    this.empresaSeleccionada = event.target.value;
  }

  changeArea(event){
    this.areaSeleccionada = event.target.value;
    var _area =  this.listArea.find(x=> x.idArea == this.areaSeleccionada);
    this.verFFin =_area.verFFin;
    this.verCorreo =_area.verCorreo;
  }

  validateEmail() {
    var response = false
    var email = this.email; 
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    response = re.test(String(email).toLowerCase());
    this.emailIncorrecto = response ? false : true;
    return response;
  }


  toggleVisibility(show) { 
    this.show = show;
  }

  toggleVisibility2(show) { 
    this.show2 = show;
  }

  backPoll(stepper){
    this.router.navigate(['/iniciar'], { replaceUrl: true });
    stepper.reset()
  }
  
  getDates() {
    var dateArray = [];
    var currentDate:any =  this.rangoFecha.startDate;
    var stopDate:any = this.rangoFecha.endDate;
    while (currentDate <= stopDate) {
        dateArray.push( moment(currentDate).format('YYYY-MM-DD') )
        currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }


  getDataChart(dates){
    var arrayData = [];
    dates.forEach(y=>{
      this.listArea.forEach(area=>{
        var _data = this.listSolicitudes.filter(x=> x.area == area.nombre && moment(x.fechaCreacion).format('YYYY-MM-DD') == y);
        if(_data){
          arrayData.push({name: area, values: _data.length});
        }
   
      });
    }); 
    return arrayData;
  }

  getDataChartAll(dates){
    var arrayData = [];
    var _data = this.listVisitas;
    dates.forEach(y=>{
      var data = 0
      _data.forEach(x=> {      
        var dia =  moment(x.fecha).format('YYYY-MM-DD'); 
        if(y == dia){
          data = data + 1;
        }
      });

      arrayData.push(data);
    });  
    return arrayData;
  }

  formatedRut(rut: any, $event: any) {
    if (rut) {
      var _rut =this.formatRut(rut, $event)
      
      this.getUser(_rut)
      return _rut;
    } else {
      return null;
    }
  }
    
  formatRut (texto: any, event: any) {
    if (
      event &&
      event.type != 'blur' &&
      event.code != 'Enter' &&
      event.code != '13' &&
      event.code != 13 &&
      event.charCode != '13' &&
      event.charCode != 13
    )
      return texto;

    if (texto === null || texto === undefined) return null;
    var size = texto.length;
    if (size == 1) return texto;

    //console.log('Antes: ' + texto);
    //si tiene puntos (.) o guiones (-) se los saca
    texto = (texto.slice(0, size - 1).replace(/[^\d]/gi, '') + texto.slice(size - 1).replace(/[^\d^k]/gi, '')).replace(
      /^[0]*/g,
      ''
    );
    //console.log('Después: ' + texto);

    var number = texto.substring(0, texto.length - 1);
    var dv = texto.substring(texto.length - 1);
    //agrega los puntos (.) y el guión (-)
    var rut =
      number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, function($1) {
        return $1 + '.';
      }) +
      '-' +
      dv;
    //console.log(rut);

    return rut;
  }

  //functión para aprobar la solicitud y todo el personal como aprobado
  AprobarSolicitudGlobal(id_solicitud){ 

    Swal.fire({
      title: '¿Esta seguro de realizar esta acción?',
      text: "Deseo aprobar esta solicitud  y permitir el ingreso a todas las personas que la componen. Puede añadir un comentario.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí',
      input: 'text'
    }).then((result) => {

      if(result.dismiss){
        console.log("cancelado");
      }else{
        let response = this.aprobar_solicitud_global(id_solicitud, result.value ? result.value : null);
        if(response){
          Swal.fire(
            'Solicitud aprobada',
            '',
            'success'
          );
          this.refreshPage();
        }
          
        
        
        
      }
    })

  }

  //functión para aprobar la solicitud y todo el personal como aprobado
  async aprobar_solicitud_global(id_solicitud, comentario){
    try {
      let response = await this.baseService.aprobar_solicitud_global(
        {
          idSolicitud: id_solicitud.idSolicitud, 
          idEstado: 2, 
          Comentario: comentario
        }
        ).toPromise();
      
      if(response){
        this.toastr.success('La solicitud ha sido modificada');
        return true;
      }
    } catch(error) {
      this.toastr.error('Ha ocurrido un problema');
    }
  }

  marcarAprobado(solicitud){

    Swal.fire({
      title: '¿Esta seguro de realizar esta acción?',
      text: "Deseo aprobar esta solicitud  y permitir el ingreso a todas las personas que la componen. Puede añadir un comentario.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí',
      input: 'text'
    }).then((result) => {

      if(result.dismiss){
        console.log("cancelado");
      }else{
        this.marcarSolicitud(solicitud, 2, result.value ? result.value : null); 
        Swal.fire(
          'Solicitud aprobada',
          '',
          'success'
        );
        this.refreshPage();
      }
    })
  }

  marcarTodosAprobados(modal){
    Swal.fire({
      title: '¿Esta seguro de realizar esta acción?',
      text: "Deseo aprobar esta solicitud y permitir el ingreso solo a las personas que están marcadas. Puede añadir un comentario.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí, aprobar solo marcados',
      input: 'text'
    }).then((result) => {
      if(result.dismiss){
        console.log("cancelado");
      }else{
          this.marcarSolicitudModal(modal, result.value ? result.value : null);
          Swal.fire(
            'Solicitud aprobada',
            '',
            'success'
          );
          //this.refreshPage();
      }
      // if (result.value) {
      //   this.marcarSolicitudModal(modal, result.value ? result.value : null);
      //   Swal.fire(
      //     'Solicitud aprobada',
      //     '',
      //     'success'
      //   );
      //   this.refreshPage();
      // }
    })
  }

  marcarRechazado(solicitud){
    Swal.fire({
      title: '¿Esta seguro de realizar esta acción?',
      text: "Deseo rechazar esta solicitud y denegar el ingreso a todas las personas que la componen. Puede añadir un comentario.",
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí',
      input: 'text'
    }).then((result) => {

      if(result.dismiss){
        console.log("cancelado");
      }else{
        this.marcarSolicitud(solicitud, 3, result.value); 
        Swal.fire(
          'Solicitud rechazada',
          '',
          'error'
        );
        this.refreshPage();
      }
    })
  }


  async aprobarUsuarioPendiente(solicitud){

    Swal.fire({
      title: '¿Esta seguro de realizar esta acción?',
      text: "Desea permitir el ingreso a esta persona. Puede añadir un comentario.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#6c757d',
      cancelButtonText: 'No',
      confirmButtonText: 'Sí',
      input: 'text'
    }).then((result) => {

      if(result.dismiss){
        console.log("cancelado");
      }else{
        this.aprobarSolicitudIndividual(solicitud, 2, result.value ? result.value : null);
      }

    })

  }

  async aprobarSolicitudIndividual(item, idEstado, comentario){

    var _storage = JSON.parse(localStorage.getItem('admin'));

    await this.setEstadoPersonal(item.idSolicitud, item.idPersonal, idEstado);

    await this.baseService.aprobar_Solicitud({idSolicitud: item.idSolicitud, idEstado: 2, Comentario: comentario, idUsuario: _storage.usuario.IDUSUARIO}).toPromise();
    
    if(idEstado== 2){
      var data2 = {
        email: item.email,
        idSolicitud:item.idSolicitud,
        idPersonal: item.idPersonal,
        tipo: 'Aprobada',
        empresa: item.empresa,
        area:  item.area,
        fecha: 'Desde el '+ this.formatedDateUser(item.fechaInicio) + ' hasta el ' + this.formatedDateUser(item.fechaFin),
        nombre: item.Persona
      }
      await this.baseService.enviar_email(data2).toPromise();
    }


  }


  cajas() {

    this.caja4 = this.listVisitantesActuales.length;
    this.caja1 = this.listSolicitudes.filter(x=>x.idEstado == 1).length;
    this.caja3 = this.listSolicitudes.filter(x=>x.idEstado == 2).length;
    this.caja2 = this.listSolicitudes.filter(x=>x.idEstado == 3).length;

    //cargar toda la data en las variables de los filtros (esto por estar marcado el 'Todas' por defecto)
    //this.listVisitantesActualesFilter = this.listVisitantesActuales;
  }

  ngModelChange(e) {

    var gap = (e.endDate).diff((e.startDate), 'days');
		this.prevDate = moment(e.startDate).subtract('days', gap).format('D MMMM') + ' - ' + moment(e.startDate).subtract('days', 1).format('D MMMM YYYY');
    this.fechaIBox = this.rangoFecha.startDate.format("DD-MM-YYYY");
    this.fechaFBox = this.rangoFecha.endDate.format("DD-MM-YYYY");
    this.rangoFechaInicio = this.rangoFecha.startDate.format("YYYY-MM-DD HH:mm:ss");
    this.rangoFechaFin = this.rangoFecha.endDate.format("YYYY-MM-DD HH:mm:ss");
    this.get_Solicitudes();

  }
  choosedDate(e) {
    this.inlineDate = e;
  }
  choosedDateTime(e) {
    this.inlineDateTime = e;
  }
  open(e) {
    //this.pickerDirective.open(e);
  }
  clear(e) {
    this.rangoFecha = null;
  }

  ConvertToCSV(objArray) {
    var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
      var str = '';
    var row = "";

    for (var index in objArray[0]) {
        //Now convert each value to string and comma-separated
        row += index + ',';
    }
    row = row.slice(0, -1);
    //append Label row with line break
    str += row + '\r\n';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            line += array[i][index];
        }
        str += line + '\r\n';
    }
    return str;
  }

  formatedDateCSV(date: any) {

    return moment(`${date.year}-${date.month}-${date.day}`, 'YYYY-MM-DD').format("YYYY-MM-DD");
  
  }

  download(data){ 
    this.downloadCSV = true;   
    var _fIni = moment(this.formatedDateCSV(this.rangoFechaInicio), "YYYY-MM-DD").format("YYYY-MM-DD");
    var _fFin = moment(this.formatedDateCSV(this.rangoFechaFin), "YYYY-MM-DD").format("YYYY-MM-DD");
    var dataToCsv = [];
    if(data){
      data.forEach(x=>{
       
        dataToCsv.push(x);
      });
    }
    var universalBOM = "\uFEFF";

    var csvData = this.ConvertToCSV(dataToCsv);
                           var a = document.createElement("a");
                           a.setAttribute('style', 'display:none;');
                           document.body.appendChild(a);
                           var blob = new Blob([csvData], 
                           { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";' });
    /*                       var url= window.URL.createObjectURL(blob);
                           a.href = url;
                           a.download = 'encuestas-'+_fIni+'_'+_fFin+'.xls';
                           a.click();
      */
     //saveAs(blob, 'encuestas-'+_fIni+'_'+_fFin+'.xlsx');                     
     var myTestXML =  new myExcelXML(JSON.stringify(dataToCsv));
      myTestXML.downLoad();  
      this.toastr.success('Archivo excel descargado'); 
      setTimeout(
        function() 
        {
          //window.location.reload();
          this.downloadCSV = false;
        }, 3000); 

     return 'success';
   }

  cleanJson(data){
    var response = JSON.stringify(data).replace('[','').replace(']','').split('"').join('').split(',').join(';')
    return response;  
  }


   s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  }

  async setEstadosPersonal(idSolicitud, idSolicitudesPersonal,idEstados){
    
    idSolicitudesPersonal = idSolicitudesPersonal.join(',');
    idEstados = idEstados.join(',');

    try {
      var response:any = await this.baseService.set_estados_solicitudes_personales(
            { idSolicitud: idSolicitud,
              idSolicitudesPersonal: idSolicitudesPersonal,
              idEstados: idEstados
            }
          ).toPromise();
      console.log(response);

    }catch(error) {
      console.log(error);
    }
  }

  async sendEmails(list_emails,list_idsolicitudes,list_idpersonal,list_tipo,list_empresas,list_areas,list_fechas,list_nombres){

    list_emails = list_emails.join(',');
    list_idsolicitudes = list_idsolicitudes.join(',');
    list_idpersonal = list_idpersonal.join(',');
    list_tipo = list_tipo.join(',');
    list_empresas = list_empresas.join(',');
    list_areas = list_areas.join(',');
    list_fechas = list_fechas.join(',');
    list_nombres = list_nombres.join(',');

    try {
      var response:any = await this.baseService.set_emails_estado_solicitudes(
            { 
              list_emails : list_emails,
              list_idsolicitudes : list_idsolicitudes,
              list_idpersonal : list_idpersonal,
              list_tipo : list_tipo,
              list_empresas : list_empresas,
              list_areas : list_areas,
              list_fechas : list_fechas,
              list_nombres : list_nombres
            }
          ).toPromise();
      console.log(response);

    }catch(error) {
      console.log(error);
    }

  }


}
